import _ from 'lodash'
import rg4js from 'raygun4js'

import { onBeforeSend } from './raygun.helpers'

const FILTERED_KEYS = ['session_token', 'access_token']

const SKIPPED_RG_CODES = [
  'error.auth.invalid_credentials', //
  'error.jwt.invalid',
  'error.jwt.expired',
  'error.auth.expired_session',
]

let initialized = false

export function initRaygun({
  apiKey,
  appEnv,
  appType,
  appBrand,
  appVersion,
  appRevision,
  getCustomData = undefined,
}) {
  if (!apiKey) {
    return false
  }

  rg4js('enableCrashReporting', true)
  rg4js('enablePulse', false)
  rg4js(
    'withTags',
    [appEnv, window.location.host, appBrand, appType, appVersion, appRevision].filter((x) => x),
  )
  rg4js('logContentsOfXhrCalls', true)
  rg4js('filterSensitiveData', FILTERED_KEYS)
  rg4js('setFilterScope', 'all')
  rg4js('onBeforeSend', onBeforeSend(FILTERED_KEYS))
  rg4js('apiKey', apiKey)

  if (typeof getCustomData === 'function') {
    rg4js('withCustomData', getCustomData)
  }

  initialized = true
}

export function setRG(event, params) {
  if (!initialized) {
    return false
  }

  params = _.cloneDeep(params)

  function clearParams(data) {
    let result = data

    _.forEach(data, (x, key) => {
      if (_.isObject(x) || _.isArray(x)) {
        result[key] = clearParams(x)
      } else if (key === 'access_token') {
        result[key] = '***'
      }
    })

    return result
  }

  let isSend = true

  if (params.customData) {
    const code = _.get(params, 'customData.response.error.code')

    if (SKIPPED_RG_CODES.includes(code)) {
      isSend = false
    } else {
      params.customData = clearParams(params.customData)
    }
  }

  if (isSend) {
    rg4js(event, params)
  }
}
